// eslint-disable-next-line no-shadow
export enum HubriseResourceType {
    CATALOG = 'catalog',
    CUSTOMER = 'customer',
    CUSTOMER_LIST = 'customer_list',
    DELIVERY = 'delivery',
    INVENTORY = 'inventory',
    LOCATION = 'location',
    ORDER = 'order'
}
